import { Helmet } from 'react-helmet-async';
import ScrollToTop from '../utility/ScrollToTop';

const PrivacyPolicy = () => {
  const sections = [
    {
      title: "What personal information do we collect from the people that visit our website?",
      content: "When ordering or registering on our site, as appropriate, you may be asked to enter your name, email address or other 'personal' details to help you with your experience."
    },
    {
      title: "When do we collect information?",
      content: "We collect information from you when you fill out a form or enter information on our site."
    },
    {
      title: "How do we use your information?",
      content: "We may use the information we collect from you when you register, make a purchase, sign up for our newsletter, respond to a survey or marketing communication, surf the website, or use certain other site features in the following ways:",
      bullets: [
        "To personalise your experience and to allow us to deliver the type of content and product offerings in which you are most interested.",
        "To improve our website in order to better serve you.",
        "To allow us to better service you in responding to your customer service requests.",
        "To follow up with them after correspondence (live chat, email or phone inquiries)"
      ]
    },
    {
      title: "How do we protect your information?",
      content: "Our website is scanned on a regular basis for security holes and known vulnerabilities in order to make your visit to our site as safe as possible.",
      subPoints: [
        {
          title: "Regular Security Measures",
          text: "We use regular Malware Scanning. Your personal information is contained behind secured networks and is only accessible by a limited number of persons who have special access rights to such systems, and are required to keep the information confidential."
        },
        {
          title: "Data Encryption",
          text: "In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (SSL) technology. We implement a variety of security measures when a user enters, submits, or accesses their information to maintain the safety of your personal information."
        },
        {
          title: "Transaction Processing",
          text: "All transactions are processed through a gateway provider and are not stored or processed on our servers."
        }
      ]
    },
    {
      title: "Do we use 'cookies'?",
      content: "Yes. Cookies are small files that a site or its service provider transfers to your computer's hard drive through your Web browser (if you allow) that enables the site's or service provider's systems to recognise your browser and capture and remember certain information. For instance, we use cookies to help us remember and process the items in your shopping cart. They are also used to help us understand your preferences based on previous or current site activity, which enables us to provide you with improved services. We also use cookies to help us compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.",
      bullets: [
        "Understand and save user's preferences for future visits.",
        "Compile aggregate data about site traffic and site interactions in order to offer better site experiences and tools in the future. We may also use trusted third-party services that track this information on our behalf."
      ],
      additionalContent: "You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do this through your browser settings. Since browser is a little different, look at your browser's Help Menu to learn the correct way to modify your cookies.\n\nIf you turn cookies off it could turn off some of the features of the site."
    },
    {
      title: "Third-Party Disclosure",
      content: "We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information."
    },
    {
      title: "Third-Party Links",
      content: "Occasionally, at our discretion, we may include or offer third-party products or services on our website. These third-party sites have separate and independent privacy policies. We therefore have no responsibility or liability for the content and activities of these linked sites. Nonetheless, we seek to protect the integrity of our site and welcome any feedback about these sites.",
      subPoints: [
        {
          title: "Facebook",
          text: "Facebook's advertising requirements can be summed up by Facebook's Advertising Principles. They are put in place to provide a positive experience for users. https://mbasic.facebook.com/privacy/policy/printable/version/23954169707588482/"
        },
        {
          title: "Google",
          text: "Google's advertising requirements can be summed up by Google's Advertising Principles. They are put in place to provide a positive experience for users. https://support.google.com/adwordspolicy/answer/1316548?hl=en"
        }
      ]
    },
    {
      title: "Google AdSense Advertising",
      content: "We use Google AdSense Advertising on our website. Google, as a third-party vendor, uses cookies to serve ads on our site. Google's use of the DART cookie enables it to serve ads to our users based on previous visits to our site and other sites on the Internet. Users may opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy policy.",
      bullets: [
        "Google Display Network Impression Reporting",
        "Demographics and Interests Reporting"
      ],
      additionalContent: "We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to compile data regarding user interactions with ad impressions and other ad service functions as they relate to our website."
    },
    {
      title: "Opting out",
      content: "Users can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively, you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics Opt Out Browser add on."
    },
    {
      title: "California Online Privacy Protection Act (CalOPPA)",
      content: "CalOPPA is the first state law in the nation to require commercial websites and online services to post a privacy policy. According to CalOPPA, we agree to the following:",
      bullets: [
        "Users can visit our site anonymously.",
        "Once this privacy policy is created, we will add a link to it on our home page or as a minimum, on the first significant page after entering our website.",
        "You will be notified of any Privacy Policy changes via email.",
        "You can change your personal information by emailing us."
      ],
      subPoints: [
        {
          title: "Do Not Track Signals",
          text: "We honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track (DNT) browser mechanism is in place."
        },
        {
          title: "Third-Party Behavioral Tracking",
          text: "It's also important to note that we do not allow third-party behavioral tracking"
        }
      ]
    },
    {
      title: "COPPA (Children Online Privacy Protection Act)",
      content: "When it comes to the collection of personal information from children under the age of 13 years old, the Children's Online Privacy Protection Act (COPPA) puts parents in control. The Federal Trade Commission, United States' consumer protection agency, enforces the COPPA Rule, which spells out what operators of websites and online services must do to protect children's privacy and safety online.\n\nWe do not specifically market to children under the age of 13 years old."
    },
    {
      title: "Fair Information Practices",
      content: "The Fair Information Practices Principles form the backbone of privacy law in the United States and the concepts they include have played a significant role in the development of data protection laws around the globe.",
      subPoints: [
        {
          title: "Data Breach Notification",
          text: "In order to be in line with Fair Information Practices we will take the following responsive action, should a data breach occur we will notify you via email."
        },
        {
          title: "Individual Redress Principle",
          text: "We also agree to the Individual Redress Principle which requires that individuals have the right to legally pursue enforceable rights against data collectors and processors who fail to adhere to the law. This principle requires not only that individuals have enforceable rights against data users, but also that individuals have recourse to courts or government agencies to investigate and/or prosecute non-compliance by data processors."
        }
      ]
    },
    {
      title: "CAN SPAM Act",
      content: "The CAN-SPAM Act is a law that sets the rules for commercial email, establishes requirements for commercial messages, gives recipients the right to have emails stopped from being sent to them, and spells out tough penalties for violations.",
      subPoints: [
        {
          title: "Email Collection",
          text: "We collect your email address in order to: Send information, respond to inquiries, and/or other requests or questions"
        },
        {
          title: "Compliance",
          text: "To be in accordance with CANSPAM, we agree to the following:\n• Not use false or misleading subjects or email addresses.\n• Identify the message as an advertisement in some reasonable way.\n• Include the physical address of our business or site headquarters.\n• Monitor third-party email marketing services for compliance, if one is used.\n• Honor opt-out/unsubscribe requests quickly.\n• Allow users to unsubscribe by using the link at the bottom of each email."
        }
      ]
    }
  ];

  return (
    <div className="pt-32 pb-16 px-6 bg-white">
      <Helmet>
        <title>Privacy Policy | ProjectProse</title>
        <meta
          name="description"
          content="How ProjectProse collects, uses and protects the personal information of landlords, tenants and website visitors, including our use of cookies and Google AdSense."
        />
        <link rel="canonical" href="https://www.project-prose.com/privacy-policy" />
      </Helmet>
      <ScrollToTop />
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-16">
          <h2 className="text-sm uppercase tracking-[0.3em] text-prose-brand font-bold mb-4 border-b-4 w-fit border-prose-gold pb-2" data-aos="fade-in">
            Legal
          </h2>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-display font-bold text-prose-black leading-tight mb-6" data-aos="fade-up">
            Privacy Policy
          </h1>
          <p className="text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed" data-aos="fade-up" data-aos-delay="100">
            Your privacy is important to us. This policy outlines how we collect, use, and protect your personal information.
          </p>
        </div>

        {/* Content */}
        <div className="space-y-12" data-aos="fade-up" data-aos-delay="200">
          {sections.map((section, index) => (
            <section key={index} className="space-y-4">
              <h2 className="text-xl sm:text-2xl font-display font-bold text-prose-black mb-4 pb-3 border-b-2 border-prose-gold/20">
                {section.title}
              </h2>
              
              {section.content && (
                <div className="space-y-4">
                  {section.content.split('\n').map((paragraph, pIndex) => (
                    <p key={pIndex} className="text-gray-700 text-sm sm:text-base leading-relaxed text-justify">
                      {paragraph}
                    </p>
                  ))}
                </div>
              )}

              {section.bullets && section.bullets.length > 0 && (
                <ul className="space-y-3 ml-4 sm:ml-6">
                  {section.bullets.map((bullet, bIndex) => (
                    <li key={bIndex} className="text-gray-700 text-sm sm:text-base leading-relaxed flex gap-3">
                      <span className="text-prose-gold font-bold flex-shrink-0 mt-1">•</span>
                      <span>{bullet}</span>
                    </li>
                  ))}
                </ul>
              )}

              {section.additionalContent && (
                <p className="text-gray-700 text-sm sm:text-base leading-relaxed text-justify mt-4">
                  {section.additionalContent}
                </p>
              )}

              {section.subPoints && section.subPoints.length > 0 && (
                <div className="space-y-4 mt-4 ml-4 sm:ml-6 border-l-4 border-prose-gold/30 pl-4 sm:pl-6">
                  {section.subPoints.map((subPoint, spIndex) => (
                    <div key={spIndex} className="space-y-2">
                      <h3 className="text-base sm:text-lg font-semibold text-prose-black">
                        {subPoint.title}
                      </h3>
                      <div className="space-y-2">
                        {subPoint.text.split('\n').map((line, lIndex) => (
                          <p key={lIndex} className="text-gray-700 text-sm sm:text-base leading-relaxed text-justify">
                            {line}
                          </p>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </section>
          ))}
        </div>

        {/* Contact Section */}
        <div className="mt-16 pt-12 border-t-2 border-gray-200">
          <p className="text-gray-600 text-sm sm:text-base">
            If you have any questions about this Privacy Policy, please contact us at{' '}
            <a href="mailto:info@project-prose.com" className="text-prose-brand font-semibold hover:text-prose-gold transition-colors">
              info@project-prose.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
